"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveBonus = void 0;
var profile_api_1 = require("@l2p/profile-api");
var react_1 = require("react");
var bonuses_1 = require("../bonuses");
var useActiveBonus = function () {
    var bonuses = (0, bonuses_1.useBonuses)().data;
    return (0, react_1.useMemo)(function () {
        if (!bonuses || bonuses.length === 0)
            return null;
        return ((bonuses === null || bonuses === void 0 ? void 0 : bonuses.find(function (bonus) { return bonus.status === profile_api_1.BonusCardStatus.InProgress; })) ||
            null);
    }, [bonuses]);
};
exports.useActiveBonus = useActiveBonus;
